import React, { useEffect, useState } from "react";
import InputField from "../../../components/Forms/InputField";
import SubmissionType from "./SubmissionType";

const Question = ({ 
    active,
    questionType, setQuestionType,
    correctDate, setCorrectDate,
    dropdownValues, setDropdownValues,
    verificationRequired, setVerificationRequired,
    submissionRequired, setSubmissionRequired,
    verificationType, setVerificationType,
    question, setQuestion,
    answerLimit, setAnswerLimit,
    mcqOptions, setMcqOptions,
    title, setTitle,
    mediaType, setMediaType,
    maxMediaUploadCount, setMaxMediaUploadCount,
    maxMediaUploadSize, setMaxMediaUploadSize,
    selfImageRequired, setSelfImageRequired,
    sampleMedia, setSampleMedia,
    stateSampleMedia,setStateSampleMedia,
    description, setDescription,
    sponsored, setSponsored,
    selfImageNotPresentPenaltyPoints, setselfImageNotPresentPenaltyPoints,
    withoutSelfImagePoints, setWithoutSelfImagePoints,
    videoSubmissionPoints, setVideoSubmissionPoints,
    points, setPoints,
    bonusPoints, setBonusPoints,
    correcMCQAnswer, setCorrectMCQAnswer,
    calculateTotalPoints
}) => {

    // Handle user manually changing the points
    const handlePointsChange = (e) => {
        const manualPoints = e.target.value;
        setPoints(manualPoints);
        
        // When user manually edits points, make sure we capture that these are no longer default points
        const question = {
            questionType,
            mediaType,
            points: manualPoints,
            isDefaultPoints: false // Mark as manually set
        };
        
        // Trigger points calculation
        calculateTotalPoints();
    };
    
    // Handle the initial setup and media type changes
    useEffect(() => {
        // Get stored points or default values
        let newPoints = points;
        
        // For empty questions or when switching to media type without points
        if (questionType === 'media' && (!newPoints || newPoints === '')) {
            newPoints = mediaType === "video" ? "200" : "100";
            setPoints(newPoints);
            calculateTotalPoints();
        }
    }, []);

    return (
        <div className=' p-5  w-full'>
            <div className='flex flex-grow gap-2'>
                <InputField
                    label={'Type Of Question'}
                    value={questionType}
                    name={'questionType'}
                    type={'select'}
                    placeholder={'Select Type Of Question'}
                    required={active}
                    data={[
                        { value: 'date', placeholder: 'date' },
                        { value: 'description', placeholder: 'description' },
                        { value: 'dropdown', placeholder: 'dropdown' },
                        { value: 'mcq', placeholder: 'mcq' },
                        { value: 'media', placeholder: 'media' }
                    ]}
                    onChange={(e) => {
                        setQuestionType(e.target.value);
                        calculateTotalPoints();
                    }}
                />
                <InputField
                    label={'Verification Required'}
                    value={verificationRequired}
                    name={'verificationRequired'}
                    placeholder={'Select Verification'}
                    type={'select'}
                    required={active}
                    data={[
                        { value: true, placeholder: 'Yes', selected: true },
                        { value: false, placeholder: 'No' }
                    ]}
                    onChange={e => {
                        setVerificationRequired(e.target.value === 'true' ? true : false);
                    }}
                />
                {
                    verificationRequired && (
                    <InputField
                        label={'Mode Of Validation'}
                        value={verificationType}
                        name={'verificationType'}
                        type={'select'}
                        placeholder={'Select Mode Of Validation'}
                        required={active}
                        data={[
                            { value: 'ai', placeholder: 'AI', selected: false },
                            { value: 'manual', placeholder: 'Manual', selected: true },
                            { value: 'both', placeholder: 'Both', selected: false }
                        ]}
                        onChange={(e) => {
                            setVerificationType(e.target.value);
                        }}
                    />)
                }
            </div>
            <SubmissionType
                active={active}
                type={questionType}
                correctDate={correctDate}
                calculateTotalPoints={calculateTotalPoints}
                setCorrectDate={(value) => {
                    setCorrectDate(value);
                }}
                dropdownValues={dropdownValues}
                setDropdownValues={value => {
                    setDropdownValues(value);
                }}
                verificationRequired={verificationRequired}
                setVerificationRequired={value => {
                    setVerificationRequired(value);
                }}
                submissionRequired={submissionRequired}
                setSubmissionRequired={value => {
                    setSubmissionRequired(value);
                }}
                verificationType={verificationType}
                setVerificationType={value => {
                    setVerificationType(value);
                }}
                question={question}
                setQuestion={(value) => {
                    setQuestion(value);
                }}
                answerLimit={answerLimit}
                setAnswerLimit={(value) => {
                    setAnswerLimit(value);
                }}
                mcqOptions={mcqOptions}
                setMcqOptions={value => {
                    setMcqOptions(value);
                }}
                title={title}
                setTitle={value => {
                    setTitle(value);
                }}
                mediaType={mediaType}
                setMediaType={value => {
                    setMediaType(value);
                }}
                maxMediaUploadCount={maxMediaUploadCount}
                setMaxMediaUploadCount={value => {
                    setMaxMediaUploadCount(value);
                }}
                maxMediaUploadSize={maxMediaUploadSize}
                setMaxMediaUploadSize={value => {
                    setMaxMediaUploadSize(value);
                }}
                selfImageRequired={selfImageRequired}
                setSelfImageRequired={value => {
                    setSelfImageRequired(value);
                }}
                image={sampleMedia}
                setImage={value => {
                    setSampleMedia(value);
                }}
                stateImage={stateSampleMedia}
                setStateImage={value => {
                    setStateSampleMedia(value);
                }}
                description={description}
                setDescription={value => {
                    setDescription(value);
                }}
                sponsored={sponsored}
                setSponsored={value => {
                    setSponsored(value);
                }}
                selfImageNotPresentPenaltyPoints={selfImageNotPresentPenaltyPoints}
                setselfImageNotPresentPenaltyPoints={value => {
                    setselfImageNotPresentPenaltyPoints(value);
                }}
                withoutSelfImagePoints={withoutSelfImagePoints}
                setWithoutSelfImagePoints={value => {
                    setWithoutSelfImagePoints(value);
                }}
                videoSubmissionPoints={videoSubmissionPoints}
                setVideoSubmissionPoints={value => {
                    setVideoSubmissionPoints(value);
                }}
                points={points}
                setPoints={value => {
                    setPoints(value);
                }}
                bonusPoints={bonusPoints}
                setBonusPoints={value => {
                    setBonusPoints(value);
                }}
                correcMCQAnswer={correcMCQAnswer}
                setCorrectMCQAnswer={value => {
                    setCorrectMCQAnswer(value);
                }}
            />
            <div className="flex flex-grow gap-3 mt-5">
                <InputField
                    label={'Points For This Question'}
                    placeholder={'Enter Points'}
                    name={'points'}
                    value={points
                        //  || (questionType === "media" ? mediaType === "video" ? "200" : "100" : "")
                        }
                    type={'number'}
                    required={active}
                    onChange={e => {
                        handlePointsChange(e);
                    }}
                />
                {/* <InputField
                    label={'Total Points'}
                    placeholder={'Total Points'}
                    disabled={true}
                    value={totalPoints}
                    type={'number'}
                    required={active}
                    onChange={e => {
                        setPoints(e.target.value);
                        handleUpdate();
                    }}
                /> */}
                {/* <div className="self-end">
                    <ActionButton
                        variant={'white'}
                        text={'Update Points'}
                        handleSubmit={() => {
                            if(pointsAdded) return;
                            setTotalPoints(totalPoints + parseInt(points));
                            handleUpdate();
                            setPointsAdded(true);
                        }}
                    />
                </div> */}
                {/* <InputField
                    label={'Bonus Points For This Question'}
                    placeholder={'Enter Bonus Points'}
                    value={bonusPoints}
                    type={'number'}
                    required={active}
                    onChange={e => {
                        setBonusPoints(e.target.value)
                        handleUpdate();
                    }}
                /> */}
            </div>
        </div>
    );
}

export default Question;